import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationState {
  currentTaskId: string;
  clickRefresh: number;
}

export const initialNotificationState: NotificationState = {
  currentTaskId: '',
  clickRefresh: 0,
};

/**
 * The redux reducer used for notification state management.
 */
const notificationSlice = createSlice({
  name: 'NOTIFICATIONS',
  initialState: initialNotificationState,
  reducers: {
    updateNotifications: (state, action: PayloadAction<NotificationState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;
